import { Dialog, DialogActions, DialogContent, Portal } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router';

const Deeplink = () => {
    const { caseId,activityNav } = useParams();
    const [redirectLink,setRedirectLink] = useState(null);
    const [isMobile,setIsMobile] = useState(null);
    const [isDialogOpen,setIsDialogOpen] = useState(false);
    const [device,setDevice] = useState(null);

    useEffect(()=>{
      if(!isMobile && redirectLink){
        window.location.href = redirectLink;        
      } else if(isMobile && device === 'ios'){
        window.location.href = `com.evidentdigital.evident://case-viewer/${caseId}`;
        setTimeout(() => {
          window.location.href = getOS();
        }, 2000);   
      }
    },[isMobile,redirectLink]);

    useEffect(()=>{
      const platform = navigator.userAgentData?.platform?.toLowerCase();
      const userAgent = navigator.userAgent.toLowerCase();

      const isAdroid = platform && (platform.includes("android") || userAgent.includes("android"));
      const isIos = /iphone|ipad|ipod/i.test(userAgent);
      setDevice(isAdroid ? 'android' : isIos ? 'ios' : null);
      if(!isAdroid && !isIos){
        const webRedirect = process.env.REACT_APP_WEB_REDIRECT?.split("=")[1] || "hub.evidentdigital.com/";
        const cleanRedirect = webRedirect.endsWith("/") ? webRedirect : `${webRedirect}/`;
        setRedirectLink(`${cleanRedirect}cases/${caseId}/${activityNav}`);
        setIsMobile(false);
      } else {
        // setRedirectLink(`com.evidentdigital.evident://case-viewer/${caseId}`);
        setIsMobile(true);
        setIsDialogOpen(true);
      }
    },[]);

    

    const getOS = () => {
      const platform = navigator.userAgentData?.platform?.toLowerCase();
        if (platform) {
            if (platform.includes("android")) return "https://play.google.com/store/apps/details?id=com.evidentdigital.evident";
            if ((platform.includes("ios") || platform.includes("mac")) && navigator.maxTouchPoints > 1) {
                return "https://apps.apple.com/app/evismart-app/id6737177426";
            }
        }

        const userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.includes("android")) return "https://play.google.com/store/apps/details?id=com.evidentdigital.evident";
        if (/iphone|ipad|ipod/.test(userAgent) || (userAgent.includes("macintosh") && navigator.maxTouchPoints > 1)) {
            return "https://apps.apple.com/app/evismart-app/id6737177426";
        }

        // Check if it's a macOS laptop (not a touchscreen device)
        if (userAgent?.includes("mac") && navigator.maxTouchPoints === 0) {
          return process.env.REACT_APP_WEB_REDIRECT?.split("=")[1] || "https://hub.evidentdigital.com/";
        }

        const webRedirect = process.env.REACT_APP_WEB_REDIRECT?.split("=")[1] || "hub.evidentdigital.com/";
        const cleanRedirect = webRedirect.endsWith("/") ? webRedirect : `${webRedirect}/`;
        return `${cleanRedirect}cases/${caseId}/${activityNav}`;
    };

      const confirmClickHandler = () => {
        window.location.href = `com.evidentdigital.evident://case-viewer/${caseId}`;
        setTimeout(() => {
          window.location.href = getOS();
        }, 2000);
      }

      const clickCancelHandler = () => {
        // setIsDialogOpen(false);
        window.location.href = process.env.REACT_APP_WEB_REDIRECT?.split("=")[1];
      }

  return <>
    {isMobile && device === 'android' && <Portal>
      <Dialog open={isMobile && isDialogOpen}>
        <DialogContent style={{padding:'40px'}}>
          Open in EviSmart App?
        </DialogContent>
        <DialogActions 
          style={{
            paddingRight: '20px',
            paddingBottom: '20px'
          }}
        >
          <button 
            onClick={clickCancelHandler}
            style={{
              color:'#03C75A',
              border:'solid thin #03C75A',
              backgroundColor:'white',
              fontFamily:'Helvetica',
              fontsize:'18px',
              fontWeight:'normal',
              lineHeight:'120%',
              margin:0,
              textDecoration:'none',
              textTransform:'none',
              borderRadius: '2px',
              padding: '5px 15px',
              cursor: 'pointer',
              marginLeft: '10px',
              width: '75px'
            }}  
          >
            Cancel
          </button>
          <button 
            onClick={confirmClickHandler}
            style={{
              background:'#03C75A',
              color:'white',
              fontFamily:'Helvetica',
              fontsize:'18px',
              fontWeight:'normal',
              lineHeight:'120%',
              margin:0,
              textDecoration:'none',
              textTransform:'none',
              border:'solid thin #03C75A',
              borderRadius: '2px',
              padding: '5px 15px',
              cursor: 'pointer',
              marginLeft: '10px',
              width: '75px'
            }}  
          >
            Open
          </button>
        </DialogActions>
      </Dialog>
    </Portal>}
  </>;
}

export default Deeplink